import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { SVGIcon } from '@shared/Frontend/utils/svg'
import React from 'react'
import { BlockHeader } from '../shared/blockHeader'
import { NestedBlocks } from '../shared/nestedBlocks/nestedBlocks'

export const TextReadMoreBlock: BlocksView['TextReadMoreBlock'] = (props) => {
  const { id, text, closeLabel, nestedBlocks, openLabel, printMode } = props

  const { inView, ref } = useInView({ threshold: 0.1 })
  const [open, setOpen] = React.useState<boolean>(false)
  return (
    <section
      id={id}
      ref={ref}
      className={cn('block block--text block--text-readmore ls-spacing', inView && 'inview')}
    >
      <div className="block__inner ls-container ls-gutter">
        <BlockHeader {...props} />

        <div className="block__content">
          <div className="block__text text--styled" dangerouslySetInnerHTML={{ __html: text }} />
        </div>

        <details
          className="block__readmore readmore"
          open={open || printMode}
          onToggle={(e) => {
            if (!printMode) {
              setOpen(e.currentTarget.open)
              if (e.currentTarget.open) {
                pushDatalayer({
                  category: 'readmore_block',
                  label: openLabel,
                  action: 'open_item',
                })
              }
            }
          }}
        >
          <summary className="readmore__summary">
            <span className="readmore__title">{open ? closeLabel : openLabel}</span>
            <SVGIcon id="icon-chevron-down" className="readmore__icon" />
          </summary>

          {nestedBlocks && (
            <div className="readmore__blocks">
              <NestedBlocks {...props} />
            </div>
          )}
        </details>
      </div>
    </section>
  )
}
